export const environment = {
  production: true,
  buildId: '2695609656218511',
  configFile: 'config.json',
};
